import {
  Maybe,
  ENUM_COMPONENTSHAREDCARDSTORYITEM_KIND,
  ENUM_COMPONENTSHAREDCARDSTORYITEM_POSITION,
} from './globalTypes'

import ribbonStoriesFragmentRawString from '../../fragments/RibbonStoriesFragment.graphql'

export const ribbonStoriesFragmentString = ribbonStoriesFragmentRawString

export type RibbonStoriesFragment = {
  __typename: 'ComponentSectionsRibbonStories'
  ribbonStory: Maybe<
    Maybe<{
      kind: ENUM_COMPONENTSHAREDCARDSTORYITEM_KIND
      title: Maybe<string>
      description: Maybe<string>
      position: Maybe<ENUM_COMPONENTSHAREDCARDSTORYITEM_POSITION>
      isHorizontal: Maybe<boolean>
      frontImage: Maybe<{
        url: string
      }>
    }>[]
  >
}

export const isRibbonStoriesFragment = (
  fragment: any,
): fragment is RibbonStoriesFragment =>
  fragment &&
  fragment.__typename === 'ComponentSectionsRibbonStories' &&
  (fragment.ribbonStory === null ||
    (Array.isArray(fragment.ribbonStory) &&
      fragment.ribbonStory
        .slice(0, 5)
        .reduce(
          (accum: any, next: any) =>
            accum &&
            (next === null ||
              (next &&
                (next.kind === 'card' || next.kind === 'text') &&
                (next.title === null || typeof next.title === 'string') &&
                (next.description === null ||
                  typeof next.description === 'string') &&
                (next.position === null ||
                  next.position === 'top' ||
                  next.position === 'center' ||
                  next.position === 'bottom') &&
                (next.isHorizontal === null ||
                  typeof next.isHorizontal === 'boolean') &&
                (next.frontImage === null ||
                  (next.frontImage &&
                    typeof next.frontImage.url === 'string')))),
          true,
        )))
